export default __webpack_public_path__ + "static/media/WhatsApp Community_Al Ghurair.270977da.png";